import * as React from 'react';
import { SVGProps } from 'react';

const SvgAdressOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.406 10.364C4.406 16.09 12 21 12 21s7.594-4.91 7.594-10.636C19.594 6.297 16.194 3 12 3c-4.194 0-7.594 3.297-7.594 7.364ZM12 13.739a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAdressOutlined;
